export default "__VITE_ASSET__mvVOWU6s__"